import { API_URL } from "util/consts";

const createHeaders = (isFile = false) => {
  const token = localStorage.getItem("token");
  const headers = {
    Accept: "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  if (!isFile) {
    headers["Content-Type"] = "application/json";
  }

  return headers;
};

const GET = async (endpoint, params) => {
  let paramsUri = "";

  if (params) {
    paramsUri =
      "?" +
      Object.entries(params)
        .map(([key, value]) => {
          if (Array.isArray(value)) {
            return value.map((item) => `${key}[]=${item}`).join("&");
          }
          return `${key}=${value}`;
        })
        .join("&");
  }
  return fetch(`${API_URL}${endpoint}${paramsUri}`, {
    method: "GET",
    headers: createHeaders(),
  }).then((response) => response.json());
};

const POST = async (endpoint, body = {}, isFile = false) => {
  return fetch(`${API_URL}${endpoint}`, {
    method: "POST",
    headers: createHeaders(isFile),
    body: isFile ? body : JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status === "success") {
        return response.data;
      } else {
        return response;
      }
    });
};

export const publicEndpoints = {
  getPage: (username, projectSlug, params) => {
    return GET(`live/projects/${username}/${projectSlug}`, params);
  },
  sendReply: (username, projectSlug, data) => {
    return POST(`live/projects/${username}/${projectSlug}`, {
      response: JSON.stringify(data),
    });
  },
};
